<template>
  <van-card :desc="data[descField]" class="article-item" @click="onClick(data)">
    <div class="thumb" slot="thumb">
      <img
        v-if="(isKeShi && !data[imgField]) || data[imgField] == '/baner1.jpg'"
        src="/baner3.png"
        alt=""
      />
      <img
        v-else-if="data[imgField].indexOf($config.fileUrl) > -1"
        :src="data[imgField]"
        alt=""
      />
      <img v-else :src="$config.fileUrl + '/' + data[imgField]" alt="" />
    </div>
    <div class="title" slot="title">
      {{ data[titleField] }}
    </div>
    <div slot="tags">
      <div class="text-less" style="font-size:0.3rem;">
        {{ data[dateField] }}
      </div>
    </div>
  </van-card>
</template>

<script>
import { Card } from "vant";
export default {
  components: {
    [Card.name]: Card,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    titleField: {
      type: String,
      default: "title",
    },
    descField: {
      type: String,
      default: "subTitle",
    },
    dateField: {
      type: String,
      default: "creationTime",
    },
    imgField: {
      type: String,
      default: "imgUrl",
    },
    isKeShi: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(data) {
      this.$emit("click", data);
    },
  },
};
</script>

<style lang="less" scoped>
.article-item {
  .title {
    font-weight: bold;
    font-size: 0.4rem;
  }
  .van-card__thumb {
    width: 1.7rem;
    height: 1.7rem;
  }
  .van-card__content {
    min-height: 1.7rem;
  }
  .thumb {
    img {
      width: 100%;
    }
  }
}
</style>
